import { render, staticRenderFns } from "./MenuTopInfos.vue?vue&type=template&id=5c64f8b4&scoped=true&"
import script from "./MenuTopInfos.vue?vue&type=script&lang=js&"
export * from "./MenuTopInfos.vue?vue&type=script&lang=js&"
import style0 from "./MenuTopInfos.vue?vue&type=style&index=0&id=5c64f8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c64f8b4",
  null
  
)

export default component.exports